// src/components/Filter/Actions/applyAction.ts
import { ApplyFiltersParams } from './types';

export const applyAction = async ({
  currentFilters,
  actions,
  uiState,
  gridRef,
}: ApplyFiltersParams): Promise<void> => {
  const { setActiveFilters, setAgGridFilters, fetchData } = actions;
  const { setIsLoading, setFiltersApplied, setHasFilterChanges } = uiState;
  const grid = typeof gridRef === 'function' ? null : gridRef?.current;

  try {
    setIsLoading(true);
    setFiltersApplied(false);

    // Apply filters and fetch data
    setActiveFilters(currentFilters);
    await fetchData(currentFilters);

    // Update UI state
    setFiltersApplied(true);
    setHasFilterChanges(false);
  } catch (error) {
    console.error('Error applying filters:', error);
    throw new Error('Failed to apply filters');
  } finally {
    setIsLoading(false);
  }
};
